module.exports = __webpack_public_path__ + "img/unitInfo.085cb965.png";